/*---------------------------------------------------------------------------------------------
 *  Copyright (c) i-Bridge Systems Philippines Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
import { Box, Typography } from '@mui/material';
import {
  Chart,
  BarSeries,
  ArgumentAxis,
} from '@devexpress/dx-react-chart-material-ui';
import { Animation } from '@devexpress/dx-react-chart';
import { Fragment } from 'react';
import { ContentContainer } from '../index';

const subs = {
  fontWeight: '500',
  fontSize: '12px',
  textTransform: 'uppercase',
  textAlign: 'center',
  color: '#828282',
};

const getPath = (x, width, y, y1) => `M ${y1} ${x}
   L ${y1} ${width + x} 
   L ${y} ${width + x} 
   L ${y} ${x + width / 2} 
   L ${y} ${x} 
   Z`;

const labelStyle = { fill: '#FFF', fontSize: '14px' };

const BarWithLabel = ({
  arg,
  barWidth,
  maxBarWidth,
  val,
  startVal,
  color,
  value,
  style,
}) => {
  const width = maxBarWidth * barWidth;
  return (
    <Fragment>
      <path
        d={getPath(arg - width / 2, width, val, startVal)}
        fill={color}
        style={style}
      />
      <Chart.Label
        x={val + startVal + 30}
        y={arg}
        dominantBaseline="middle"
        textAnchor="middle"
        style={labelStyle}
      >
        {value}
      </Chart.Label>
    </Fragment>
  );
};

export const HoursWorked = (props) => {
  return (
    <ContentContainer>
      <Typography
        variant="h5"
        fontWeight={600}
        textAlign="center"
        textTransform={'uppercase'}
      >
        {props.title}
      </Typography>
      <Typography sx={subs}>
        From {props.fromDate} to {props.toDate}
      </Typography>
      <Box sx={{ pl: 3, pr: 10 }}>
        <Chart rotated height={580} data={props.cleanData}>
          <ArgumentAxis indentFromAxis={5} showTicks={false} />
          <BarSeries
            color="#84d8c5"
            barWidth={0.8}
            valueField="hours"
            argumentField="name"
            pointComponent={BarWithLabel}
          />
          <Animation />
        </Chart>
      </Box>
    </ContentContainer>
  );
};
